this.triggerNps = function(personName, email, personId, tenantId, roles, jobPositions) {
	(function(f,b,g){
		var a={
		   key:"3e66c20819dfb841",
		   campaign:"adbe09ec",
		   name: personName,
		   email: email,
		   identification: personId,
		   tags: {
			"tenant": tenantId,
			"perfil_acesso": roles,
			"nivel_hierarquico": jobPositions
		   }
	};var e;var c=f.getElementsByTagName(b)[0];if(f.getElementById(g)){return}e=f.createElement(b);e.id=g;e.src="https://cdn.tracksale.co/tracksale-js/tracksale.js";e.type="text/javascript";e.async=true;e.onload=e.onreadystatechange=function(){var h=this.readyState;if(h&&h!="complete"&&h!="loaded"){return}try{var d=new Tracksale();d.init(a)}catch(i){}};c.parentNode.insertBefore(e,c)}(document,"script","tracksale-js"));
}
